import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VDropdownHeading' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ''
		},
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    role: "presentation",
    class: _normalizeClass(_unref(clsx)(__props.className, 'col-span-full grid grid-cols-[1fr,auto] gap-x-12 px-3.5 pb-1 pt-2 text-sm/5 font-medium text-zinc-500 sm:px-3 sm:text-xs/5 dark:text-zinc-400'))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})